import { render, staticRenderFns } from "./qcSetPage.vue?vue&type=template&id=728df923&scoped=true&"
import script from "./qcSetPage.vue?vue&type=script&lang=js&"
export * from "./qcSetPage.vue?vue&type=script&lang=js&"
import style0 from "./qcSetPage.vue?vue&type=style&index=0&id=728df923&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728df923",
  null
  
)

export default component.exports